import { Skeleton } from '@/_shared/components/ui/skeleton';

export function SettingsCardsSkeleton({ count = 2 }: { count?: number }): React.ReactElement {
  return (
    <div className="grid gap-2">
      {Array.from({ length: count }, (_, i) => (
        <Skeleton key={i} className="h-20 w-full rounded-lg" />
      ))}
    </div>
  );
}
